import app from 'flarum/forum/app';

/*
 * The language menu comes from the server (see Scoreflection\Translate\Languages)
 * so the composer and the settings page cannot drift apart, or from the data.
 * The fallback only covers a forum whose extension assets are stale.
 */
export default function supportedLangs() {
  return app.forum.attribute('sfTranslateLangs') || ['en', 'de'];
}
